import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routerConfig'
import axios from 'axios'
import { BASE_URL_SERVER } from '../main.js'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({ y: 0, x: 0 }),
    routes
})
const validRoute = ['login','register','review_success','c_r','d_r']

function forceToLogin(to) {
    localStorage.setItem("urlBeforeLogin",to.path);
    window.location.href = "/login";
}

function forceToIndex(){
    window.location.href = "/index";
}

let userToken = localStorage.getItem("current_user_token");

router.beforeEach((to, from, next) => {
    if(to.path==='/'){
        router.replace({path:'/index'});
    }
    if(validRoute.indexOf(to.name)!==-1){
        next();
    }else if(userToken){
        let authData = localStorage.getItem('authData');
        let serverExpireTime = new Date(JSON.parse(window.atob(userToken.split('.')[0])).exp);
        if(!authData||Date.now()>serverExpireTime){
            forceToLogin(to);
        }else{
            let authObject = JSON.parse(authData);
            if(Date.now()>authObject.expireTime){
                axios.post(
                        BASE_URL_SERVER + "/base_authority", 
                        { userToken: userToken }
                    ).then(response => {
                    if (response.data.stat !== "authority_pass") {
                        forceToLogin(to);
                    } else {
                        let resAuthData = {
                            barRights:response.data.barRights,
                            sfileRight:response.data.sfileRight,
                            expireTime:Date.now()+1000*3600*4,
                        };
                        localStorage.setItem('authData',JSON.stringify(resAuthData));
                        if(resAuthData.barRights.indexOf(to.name)!==-1||resAuthData.barRights.indexOf('super_all')!==-1||to.name==='index'||to.name==='main'){
                            next();
                        }else{
                            forceToIndex();
                        }
                    }
                    });             
            }else{
                if(authObject.barRights.indexOf(to.name)!==-1||authObject.barRights.indexOf('super_all')!==-1||to.name==='index'||to.name==='main'){
                    next();
                }else{
                    forceToIndex();
                }
            }
        }
    }else if(!userToken){
        forceToLogin(to);
    }
    else{
        next();
    }

})

export default router